import request from "../services/requestService";
import * as apiServices from "../services/apiServices";
import {
  CREATE_PROJECT_ACTION,
  FILTERS_ACTIONS,
  ISSUE_ACTION,
  PROJECT_AWARDED_BY
} from "../constant";
import { get } from "lodash";
import {
  RemoveEmptyFieldsHelper,
  setLocalstorage,
  transformIssueListPayload
} from "../helper";
import { getissueListParams } from "../services/apiServices";

export const createIssueAction = (requestMethod = request, data) => {
  return function(dispatch) {
    dispatch({
      type: CREATE_PROJECT_ACTION.CREATE_PROJECT_PAGE_INFO_START
    });
    return requestMethod(apiServices.createIssues(data))
      .then(resp => {
        const data = get(resp, "data");
        dispatch({
          type: CREATE_PROJECT_ACTION.CREATE_PROJECT_PAGE_INFO_SUCCESS
        });
        return {
          data: get(data, "data"),
          status: get(data, "status"),
          message: get(data, "message")
        };
      })
      .catch(() => {
        dispatch({
          type: CREATE_PROJECT_ACTION.CREATE_PROJECT_PAGE_INFO_FAILURE
        });
      });
  };
};

export const updateIssueAction = (requestMethod = request, data, id) => {
  return function(dispatch) {
    dispatch({
      type: CREATE_PROJECT_ACTION.CREATE_PROJECT_PAGE_INFO_START
    });
    return requestMethod(apiServices.updateIssues(data, id))
      .then(resp => {
        const data = get(resp, "data");
        dispatch({
          type: CREATE_PROJECT_ACTION.CREATE_PROJECT_PAGE_INFO_SUCCESS
        });
        return {
          data: get(data, "data"),
          status: get(data, "status"),
          message: get(data, "message")
        };
      })
      .catch(() => {
        dispatch({
          type: CREATE_PROJECT_ACTION.CREATE_PROJECT_PAGE_INFO_FAILURE
        });
      });
  };
};

export const getIssuesStatesAction = (requestMethod = request, data) => {
  return function(dispatch) {
    dispatch({
      type: CREATE_PROJECT_ACTION.GET_ISSUES_STATES_START
    });
    return requestMethod(apiServices.issuesGuestList(data))
      .then(resp => {
        const data = get(resp, "data");
        const list = {
          data: get(data, "data"),
          status: get(data, "status"),
          message: get(data, "message")
        };
        dispatch({
          type: CREATE_PROJECT_ACTION.GET_ISSUES_STATES_SUCCESS,
          payload: list
        });
        return list;
      })
      .catch(() => {
        dispatch({
          type: CREATE_PROJECT_ACTION.GET_ISSUES_STATES_FAILURE
        });
      });
  };
};

export const isIssueDuplicatedAction = (requestMethod = request, data) => {
  return requestMethod(apiServices.issueDuplicateAPI(data))
    .then(resp => {
      const data = get(resp, "data");
      return {
        data: get(data, "data"),
        status: get(data, "status"),
        message: get(data, "message")
      };
    })
    .catch(e => {
      return e;
    });
};

// default params
const defaultIssueListFilters = {
  offset: 0,
  limit: 10,
  groupCategory: PROJECT_AWARDED_BY.CENTRAL
};

export function _getIssueList(params = {}, removeSortFilter = false) {
  return async dispatch => {
    let filters = RemoveEmptyFieldsHelper({
      ...defaultIssueListFilters,
      ...params
      // search: params.search ? params.search.trim() : "",
    });
    const filterTrasform = transformIssueListPayload(filters);
    if (!filterTrasform.category) {
      delete filters.subCategory;
    }
    if (filterTrasform.projectGroupBy && removeSortFilter) {
      delete filters.sortOrder;
      delete filters.sortBy;
    }
    if (!filterTrasform.recipientCenter && !filterTrasform.recipientState) {
      delete filters.issueDistStateDept;
    }
    dispatch({ type: FILTERS_ACTIONS._ISSUE_LIST_._START, payload: filters });
    const response = await request(
      getissueListParams(transformIssueListPayload(filters))
    );
    const { data, status } = response.data || {};
    if (status) {
      setLocalstorage("draftedProject", data.draftStatus.drafted || null);
      dispatch({
        type: FILTERS_ACTIONS._ISSUE_LIST_._SUCCESS,
        payload: data
      });
    } else
      dispatch({ type: FILTERS_ACTIONS._ISSUE_LIST_._FAILURE, payload: [] });
  };
}

export function CLEAR_ISSUE_OLD_FILTERS_ACTION(
  projectAwardedBy = PROJECT_AWARDED_BY.CENTRAL
) {
  return function(dispatch) {
    dispatch({
      type: FILTERS_ACTIONS._ISSUE_LIST_._CLEAR,
      payload: {
        ...defaultIssueListFilters,
        ...{ groupCategory: projectAwardedBy }
      }
    });
    // call api
    dispatch(_getIssueList({ groupCategory: projectAwardedBy }));
  };
}

export function unHoldIssueAction(id) {
  return async () => {
    const response = await request(apiServices._unHoldIssueAction(id));
    const { status } = response.data || {};
    if (status) {
      return response.data;
    } else console.log("error in unholding issue");
  };
}

export const markAsDuplicate = (data, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: ISSUE_ACTION.MARK_ISSUE_DUPLICATE_START
    });
    return requestMethod(apiServices._markAsDuplicate(data))
      .then(resp => {
        const data = get(resp, "data");
        dispatch({
          type: ISSUE_ACTION.MARK_ISSUE_DUPLICATE_SUCCESS
        });
        return {
          data: get(data, "data"),
          status: get(data, "status"),
          message: get(data, "message")
        };
      })
      .catch(() => {
        dispatch({
          type: ISSUE_ACTION.MARK_ISSUE_DUPLICATE_FAILURE
        });
      });
  };
};
